import * as d3 from 'd3-format'
import theme from '../../../../themes/pTheme/pTheme'

const getSortField = (dimension) => {
  if (dimension === 'Age') return 'binNameUpdated'
  if (dimension === 'Income Level') return 'incomeSortValue'
  return 'binIndex'
}

export function sortData(data, dimension) {
  const sortField = getSortField(dimension)
  return [...data].sort((a, b) => {
    const aVal = a[sortField]
    const bVal = b[sortField]
    if (typeof aVal === 'number' && typeof bVal === 'number') return aVal - bVal
    if (aVal < bVal) return -1
    if (aVal > bVal) return 1
    return 0
  })
}

function truncateLabel(label) {
  if (typeof label !== 'string') return String(label)
  return label.length > 20 ? label.substring(0, 20) + '...' : label
}

export function buildChartJsData(populationDistribution, updatedColors, dimension) {
  const sorted = sortData(populationDistribution, dimension)
  const states = [...new Set(sorted.map((d) => d.state))]
  const bins = [...new Set(sorted.map((d) => d.binNameUpdated))]

  const labels = bins.map((b) => truncateLabel(b))

  const datasets = states.map((state, i) => {
    const stateData = bins.map((bin) => {
      const entry = sorted.find((d) => d.state === state && d.binNameUpdated === bin)
      return entry || null
    })

    return {
      label: state,
      data: stateData.map((e) => (e ? Number(e.count) : 0)),
      backgroundColor: updatedColors[i] || updatedColors[0],
      borderWidth: 0,
      barPercentage: 0.9,
      categoryPercentage: 0.85,
      _raw: stateData
    }
  })

  return {labels, datasets, bins}
}

export function getPopulationDistributionOptions(selectedYAxisView) {
  const fontFamily = theme.typography.fontFamily

  const tickColor = theme.palette.hpBaseDarkest

  return {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    layout: {
      padding: {bottom: 10, left: 20, top: 0, right: 0}
    },
    scales: {
      x: {
        grid: {display: false},
        ticks: {
          maxRotation: 45,
          minRotation: 45,
          font: {family: fontFamily, size: 12},
          color: tickColor,
          autoSkip: false
        },
        title: {display: false}
      },
      y:
        selectedYAxisView === 'percentage'
          ? {
              min: 0,
              max: 100,
              grid: {drawOnChartArea: false, drawTicks: true, tickLength: 6},
              ticks: {
                stepSize: 10,
                font: {family: fontFamily, size: 12},
                color: tickColor,
                callback: (value) => value + '%'
              },
              title: {display: false}
            }
          : {
              grid: {drawOnChartArea: false, drawTicks: true, tickLength: 6},
              ticks: {
                font: {family: fontFamily, size: 12},
                color: tickColor,
                callback: (value) => d3.format('.2s')(value)
              },
              title: {display: false}
            }
    },
    plugins: {
      legend: {display: false},
      tooltip: {enabled: false}
    }
  }
}
